<template>
   <div class="page_part4">
    <div class="page_mulu content">
 
      <h5 class="header page_header page_bg_o header_title_page"><span>Part.2 智能水平</span></h5>
      <h6 class="page_title_2">
        <span>智能水平</span><span class="arrow"></span>
      </h6>
      <div class="header_detail_box">
        <p class="header_detail">
          智能是在特定的文化背景或社会环境中，人们解决有意义的问题或者制造有价值的产品的能力，亦即顺利实现绘画等活动的心理条件。根据美国教育学家和心理学家加德纳（H.Gardner）博士的观点，人类思维和认识的方式是多元的，除语言和数学-逻辑智能外，还有空间-视觉、身体运动、人际、自知、自然和音乐智能。个体的各种智能并非均衡发展，了解优势智能有助于获得更好的发展。
        </p>
        <p class="header_detail">
            本测评通过客观测验的方法对以上八项智能或能力进行评估，计分采取标准分制（均分为100，标准分为25），将你的得分与群体进行比较（常模分数范围为75-125），并在各能力项结果上设置五个等级（标准得分低于75分为低，75-92分为较低，92-108分为中等，108-125分为较高，125分以上为高），帮助你看到自己的相对位置和发展优势。
        </p>
      </div>
      <div class="line_box2">
        <p class="career_page">
          <img
            src="../../../../../public/imgs/cepingreport/page_feng.png"
            alt=""
          />
          智能测评结果
        </p>
      </div>
      <div class="table">
          <table>
                    <thead>
                    <tr>
                        <th rowspan="2">智能项</th>
                        <th rowspan="2">常模范围</th>
                        <th rowspan="2">你的得分</th>
                        <th rowspan="2">出众百分比</th>
                        <th colspan="5">水平等级</th>
                    </tr>
                     <tr>
                        <th width="64"></th>
                        <th width="64"></th>
                        <th width="64"></th>
                        <th width="64"></th>
                        <th width="64"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(intell ,index) in arrResole" :key="index">
                        <td>{{intell.name}}</td>
                        <td>75-125</td>
                        <td>{{intell.standardScore}}</td>
                        <td>{{(intell.percent*100).toFixed(1)}}%</td>
                        <td colspan="5">
                            <div class="line_box">
                                <div :class="['line_score',getZBgColor(intell.standardScore)]" :style="{ width: intell.standardScore/200*324 + 'px' }" :title="intell.standardScore | toFixed(2)"></div>
                                <div class="lien_norm" :style="{left: 75/200*324 + 'px', width: (125-75)/200*324 + 'px' }"></div>
                            </div>
                         
                        </td>
                        <td></td>
                        <td></td>
                    </tr>
                    
                    </tbody>
                </table>
      </div>
    </div>
    <div class="page_mulu "> 
      <div class="line_box2 content">
        <p class="career_page">
          <img
            src="../../../../../public/imgs/cepingreport/page_feng.png"
            alt=""
          />
          智能结果解读
        </p>
      </div>
    </div>
    <div class="page_mulu">
       <div class="part3_1_main_box content" v-for="(intell ,index) in arrResole" :key="index">
        <P class="main_title career_page">{{intell.name}}</P>
        <p class="main_jie">{{intell.desc}}</p>
        <div class="main_norm_box">
            <div :class="['norm_box',getBgColor(intell.standardScore,intell.name)]" :style="{width: intell.standardScore/200*692  + 'px'}" >
                <div :class="['norm_score',getBorderColor(intell.standardScore)]">
                    <p :class="['score',getBgColor(intell.standardScore)]">{{intell.standardScore}}</p>
                </div>
                <div class="norm_block" :style="{left: 75/200*692 + 'px', width: (125-75)/200*692 + 'px' }" title="75~125"></div>
            </div>
        </div>
        <p class="main_detail">你的等级：<span :class="getColor(intell.standardScore)">{{intell.degree}}</span>
        </p>
        <P class="main_directions">等级说明：<span>{{intell.text}}</span></P>
    </div>
    </div>
   </div>
</template>

<script>
import ThePart3Main from "./ThePart3Main.vue"
export default {
  data(){
    return{
      tableArr:["语言能力","数学-逻辑能力","空间-视觉能力","身体运动能力","人际能力","自然能力","自知能力","音乐能力"]
    }
  },
  props:['intelligent'],
  components:{
    ThePart3Main
  },
  
  computed:{
    arrResole(){
      let arr=[]
      
      for(let i = 0;i<this.tableArr.length;i++){
         this.intelligent&&this.intelligent.forEach(item => {
           //console.log(item+'1')
           if(this.tableArr[i]==item.name){
            arr.push(item)
           }
         });
      }
   
      return  arr
    }
  },
  methods:{
    getBorderColor(value){
       if(value<75){
        return "norm_fout1111"
      }else if(value >=75 && value<92){
        return "norm_fout2222"
      }else if(value >=92 && value < 108){
        return "norm_fout3333"
      }else if(value >= 108 && value < 125){
        return "norm_fout4444"
      }else if(value >= 125){
        return "norm_fout5555"
      }
    },
    getZBgColor(value){
       if(value<75){
        return "norm_fout111"
      }else if(value >=75 && value<92){
        return "norm_fout222"
      }else if(value >=92 && value < 108){
        return "norm_fout333"
      }else if(value >= 108 && value < 125){
        return "norm_fout444"
      }else if(value >= 125){
        return "norm_fout555"
      }
    },
    getBgColor(value,text){
      if(value>=0 && value<75){
        return "norm_fout1"
      }else if(value >=75 && value < 92){
        return "norm_fout2"
      }else if(value >=92 && value <108){
        return "norm_fout3"
      }else if(value>=108 && value<125){
        return "norm_fout4"
      }else if(value >=125 && value < 201){
        return "norm_fout5"
      }
    },
    
    getColor(value){
      if(value>=0 && value<75){
        return "norm_fout11"
      }else if(value >=75 && value <92){
        return "norm_fout22"
      }else if(value >=92 && value <108){
        return "norm_fout33"
      }else if(value>=108 && value<125){
        return "norm_fout44"
      }else if(value >=125 && value<201){
        return "norm_fout55"
      }
    },
  }
}
</script>
<style scoped>
@import './report.css';



.norm_fout11{
  color: #FF0000;
}
.norm_fout22{
  color: #FEAE3B;
}
.norm_fout33{
  color: #1CA4B6;
}
.norm_fout44{
  color: #90D246;
}
.norm_fout55{
   color: #00B14B;
}
.norm_fout1{
  background: #FF0000;
}
.norm_fout2{
   background: #FEAE3B;
}
.norm_fout3{
  
   background: #1CA4B6;
}
.norm_fout4{
  
   background: #90D246;
}
.norm_fout5{
   background: #00B14B;
}

.norm_fout111{
  background: #FF0000;
}
.norm_fout222{
   background: #FEAE3B;
}
.norm_fout333{
  
   background: #1CA4B6;
}
.norm_fout444{
  
   background: #90D246;
}
.norm_fout555{
   background: #00B14B;
}

.norm_fout1111{
  border-right: 1px dotted #FF0000;
}
.norm_fout2222{
   border-right: 1px dotted #FEAE3B;
}
.norm_fout3333{
  border-right: 1px dotted #1CA4B6;
}
.norm_fout4444{
  border-right: 1px dotted #90D246;
}
.norm_fout5555{
  border-right: 1px dotted #00B14B;

}
.main_norm_box .norm_box .norm_score .norm_fout1:before{
  border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 10px solid #FF0000;
}
.main_norm_box .norm_box .norm_score .norm_fout2:before{
  border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 10px solid #FEAE3B;
}
.main_norm_box .norm_box .norm_score .norm_fout3:before{
  border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 10px solid #1CA4B6;
}
.main_norm_box .norm_box .norm_score .norm_fout4:before{
  border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 10px solid #90D246;
}
.main_norm_box .norm_box .norm_score .norm_fout5:before{
  border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 10px solid #00B14B;
}


.main_norm_box .norm_box .norm_score .score:before {
    content: "";
    position: absolute;
    bottom: -10px;
    left: 50%;
    margin-left: -5px;
    width: 0;
    height: 0;
   
}
 

 h5.page_bg_o {
  background-color: #feae3b;
}
 h5.header {
  color: #fff;
  font-size: 24px;
  text-align: left;
  margin-bottom: 30px;
  line-height: 50px;
  padding-left: 15px;
}
 .page_title_2 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 32px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 10px;
}

 .page_title_2 span {
  line-height: 32px;
  font-size: 20px;
  font-weight: 700;
}
 .page_title_2 .arrow {
  display: block;
  margin-left: 10px;
  width: 0;
  height: 0;
  border-top: 9px solid transparent;
  border-left: 14px solid #feae3b;
  /* border-left: 14px solid #19b1c4; */
  border-bottom: 9px solid transparent;
}
.header_detail_box .header_detail {
  text-indent: 2em;
  line-height: 32px;
  font-size: 15px;
  color: #4f4e4e;
}

.line_box2 {
  height: 38px;
  margin-top: 50px;
}
.table{
  margin-top: 20px;

}
table{
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
}
 .table tr th{
    color: #fff;
    font-size: 16px;
    line-height: 42px;
    background-color: #f6a724;
    border: 1px solid #fff;
    text-align: center;
}
 .table tr td {
    font-size: 14px;
    height: 60px;
    text-align: center;
    background-color: #f7f7f7;
    border: 1px solid #fff;
}
 .table tr td .line_box{
    height: 20px;
    position: relative;
}
 .table tr td .line_box .line_score {
    height: 20px;
}
 .table tr td .line_box .lien_norm{
    position: absolute;
    top: 0;
    height: 20px;
    background: rgba(121,119,119,.2);
}
 .c_mind5{
    background-color: #90D246;
}

.main_norm_box .norm_box .norm_score .score{
    width: 46px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    font-size: 12px;
    color: #fff;
    border-radius: 3px;
    position: absolute;
    left: -22.5px;
    top: -30px;
}



.part3_1_main_box{
    margin-top: 40px;
}
.part3_1_main_box .main_title{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
}
.part3_1_main_box .main_jie{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #969696;
    margin-top: 15px;
}
.part3_1_main_box .main_norm_box{
    background: url("../../../../../public/imgs/cepingreport/page_4_1.png") no-repeat 50%;
    background-size: 100% 100%;
    margin-top: 40px;
}

 .part3_1_main_box .main_norm_box .norm_box .norm_score{
    /* border-right: 1px dotted #f6a724; */
}
 .main_norm_box{
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 10px 10px 0 10px;
    width: 712px;
    height: 60px;
    background-size: 100% 100%;
    margin: 0 auto;
    margin-bottom: 20px;
}
/* .part3_1_main_box .main_norm_box .norm_box{
    background-color: #f6a724;
} */
.main_norm_box .norm_box{
    width: 692px;
    height: 18px;
    /* background-color: #1ca4b6; */
    position: relative;
    border-radius: 10px;
}

.main_norm_box .norm_box .norm_score{
    position: absolute;
    right: 0;
    top: -11px;
    width: 0;
    height: 40px;
    /* border-right: 1px dotted #1ca4b6; */
}

.part3_1_main_box .main_norm_box .norm_box .norm_block {
    background-color: rgba(121,119,119,.49);
}
.main_norm_box .norm_box .norm_block{
    height: 26px;
    position: absolute;
    top: -4px;
    background-color: rgba(121,119,119,.49);
}
.main_detail{
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 22px;
}
 .main_detail span{
    
    font-size: 16px;
}
.color2{
    color: #ffc001;
}

 .color1{
    color: red;
}
.part3_1_main_box .main_directions{
    padding: 15px;
    font-size: 14px;
    color: #000;
    font-weight: 600;
    line-height: 28px;
    background-color: #f7f7f7;
    border-radius: 5px;
}
.part3_1_main_box .main_directions span{
    font-size: 14px;
    font-weight: 400;
    color: #969696;
    line-height: 29px;
}
</style>